// school-ai/src/i18n/locales/en.ts
export const en = {
  common: {
    schoolAi: "School AI",
    welcome: "Welcome to our app!",
    loading: "Loading...",
    error: "An error occurred",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    submit: "Submit",
    language: "language",
    search: "Search",
    mode: "App",
    teacherLabel: "For Teachers",
    logout: "Sign out"
  },
  chat: {
    displayModes: "Display App List",
    userInput: "User Input",
    searchModes: "Search Apps",
    start: "Start",
    restartConversation: "Restart Conversation",
    tapToReply: "Tap and write a reply",
    wordCount: "words",
    imageToText: "image ▷ text",
    printChat: "Print this chat",
    submitChat: "Submit this chat",
    submitRecord: "Submit record (Trial operation)",
    confirmationForUsage: "I have checked how to use it.",
    startChat: "Start",
    searchChatByDate: "Search chats by date",
    submissionList: "List of Submission Boxes",
    selectSubmissionDestination: "Select Submission Destination",
    submissionDescription: "Chat will be submitted to the selected destination",
    withdrawnLabel: "Withdrawn",
    submit: "Submit",
    noSubmissionBoxMessage: "No submission boxes to show",
    pronunciationSubmissionDescription:
      "The pronunciation result will be submitted to the selected destination"
  },
  navigation: {
    home: "Home",
    studentGuide: "Student Guide",
    myPage: "My page",
    manageModes: "Manage Apps",
    submission: "Submissions",
    discover: "Find Apps",
    manual: "Official Guide",
    contact: "Contact"
  },
  myPage: {
    myPageTitle: "My Page",
    editMyPageInfo: "Edit personal information",
    updatePasswordFirstHalf: "Update",
    updatePasswordSecondHalf: "password",
    name: "Name",
    studentId: "Student ID",
    studentLoginId: "login ID",
    schoolId: "School ID",
    schoolName: "School name",
    classroomName: "Classroom name",
    grade: "Grade",
    freeInput: "Free input",
    email: "Email"
  },
  login: {
    agreeToTermsText: {
      withLogin: "By logging in,",
      privacyPolicy: "the privacy policy",
      and: "and",
      termsOfService: "the terms of service",
      agree: "you agree to"
    },
    qrLoginText: "Scan QR Code to Log In as Student",
    or: "OR",
    schoolId: "School ID",
    studentLoginId: "Login ID",
    email: "Email",
    password: "Password",
    loginWithStudentId: "Login with Student ID",
    loginWithEmail: "Login with Email",
    loginWithGoogle: "Login with Google",
    loginWithMicrosoft: "Login with Microsoft",
    here: "click here",
    hereCapital: "Click here",
    toLoginForTeachers: "For the teacher login page, ",
    toLoginForStudents: "For the student login page, ",
    inCaseSchoolIdMissing: "Forgot school ID? ",
    noAccountMessage:
      "If you do not have an account yet, please consult with your teacher.",
    resetPassword: "Reset password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    qrCameraError:
      "The camera could not be started. Please allow camera access, or log in with your ID and password.",
    passwordReset: {
      title: "Reset password",
      description:
        "Enter the email address of the account whose password you want to reset. We will send you a reset link.",
      cancel: "Cancel",
      send: "Send",
      success: "A password reset email has been sent. Please check your inbox.",
      failure: "The email could not be sent. Please try again later."
    },
    teacherLanding: {
      headlineStart: "Welcome to ",
      headlineAccent: "School AI",
      headlineEnd: ".",
      teacherDescription: "Please log in with your teacher account.",
      studentDescription: "Please log in with your student account.",
      teacherTab: "Teacher",
      studentTab: "Student",
      cardTitle: "Welcome back, teacher.",
      cardDescription:
        "Log in with your email address and start today's class.",
      forgotPassword: "Forgot?"
    },
    studentLanding: {
      cardTitle: "Welcome back.",
      cardDescription:
        "Continue learning with a QR code or your ID and password.",
      qrTitle: "Log in with QR code",
      qrDescription: "Scan the code your teacher gave you",
      separator: "or with ID and password",
      schoolIdHint: "School-wide number",
      loginIdHint: "Your personal ID",
      schoolIdPlaceholder: "School ID",
      loginIdPlaceholder: "Student login ID",
      loginButton: "Log in with School ID",
      qrGuide: "Fit the QR code inside the frame",
      stopScan: "Stop scanning"
    },
    errors: {
      invalidCredentials:
        "Please check your login details. Your school ID, login ID, or password may be incorrect.",
      usageExpired:
        "This school's School AI subscription has expired. Please contact your administrator.",
      // テナントのホスト向け。商品名を含めない（FR-06）
      usageExpiredNeutral:
        "This school's subscription has expired. Please contact your administrator.",
      accountSuspended:
        "This account is currently suspended and cannot use School AI. Please contact your teacher.",
      accountSuspendedNeutral:
        "This account is currently suspended. Please contact your teacher.",
      invalidRequest: "Please check your input.",
      externalLoginFailed: "External login failed. Please try again.",
      temporary: "Something went wrong. Please try again later.",
      missingLoginId: "Please enter your login ID",
      missingPassword: "Please enter your password",
      missingSchoolId: "Please enter your school ID",
      missingEmail: "Please enter your email address",
      auth: {
        invalidEmail: "The email address format is invalid",
        userDisabled: "This account has been disabled",
        invalidCredential:
          "The email address or password is incorrect. Please check and try again.",
        userNotFound: "No user account exists for this email address",
        operationNotAllowed: "Sign-in with email and password is not allowed",
        tooManyRequests:
          "Access to this account has been temporarily restricted for security reasons. Please try again later.",
        network:
          "A network error occurred. Please check your connection and try again."
      }
    }
  },
  checkSchoolId: {
    loginId: "Login ID",
    password: "Password",
    search: "Search",
    goBack: "Back to Login Page",
    title: "Check School ID",
    description: "Enter your login ID and password to look up your school ID.",
    close: "Close",
    schoolId: "School ID",
    copy: "Copy",
    copied: "Copied"
  }
};
